export default{
    BaseUrl : `https://mymeetingsapp.herokuapp.com/api`
};